import axios from "../utils/axios";

/**
 * Login - Admin Authentication
 * @param {Object} credentials - { email, password }
 * @returns {Promise} Response with token and user data
 */
export const authLogin = async (credentials) => {
    try {
        const { data } = await axios.post('/login', { ...credentials, device_name: "admin_web" });
        return data;
    } catch (error) {
        console.error("🚀 ~ authLogin ~ error:", error);
        throw error;
    }
};

/**
 * Logout - Revoke current access token
 * @returns {Promise} Response confirming logout
 */
export const authLogout = async () => {
    try {
        const { data } = await axios.post('/logout');
        return data;
    } catch (error) {
        console.error("🚀 ~ authLogout ~ error:", error);
        throw error;
    }
};

/**
 * Get Current User - Retrieve authenticated user's information
 * @returns {Promise} Response with user data and abilities
 */
export const authMe = async () => {
    try {
        const { data } = await axios.get('/profile');
        return data;
    } catch (error) {
        console.error("🚀 ~ authMe ~ error:", error);
        throw error;
    }
};
